import Organization from './organizationType';

const emptyOrganization: Organization = {
  OrgUUID: '',
  OrgName: '',
  ApiKey: '',
};

export default emptyOrganization;
